import styled, { css } from "styled-components"

import { ContainerLarge } from "~/components/layouts/Container"
import { IsMobile, IsPC, SpacingSize, Z } from "~/consts/style-mixins"

export const Container = styled(ContainerLarge)`
  margin: ${SpacingSize["4XL"]}px 0;
  ${IsMobile(css`
    margin: 24px 0 32px;
  `)}
  .company-favorite-container {
    margin: 16px 0 32px;
    display: flex;
    justify-content: space-between;
  }
  .cover-img {
    width: 100%;
    margin-bottom: 40px;
  }
  .carousel {
    margin-bottom: 56px;
  }
  .cover-img,
  .carousel-each-image {
    /* 縦横比を 5:2 にする */
    height: calc((100vw - 32px) * 0.4);
    object-fit: cover;
    ${IsPC(css`
      height: 400px;
      border-radius: 8px;
    `)}
  }
  .tab {
    ${IsMobile(css`
      width: 100vw;
      margin: 0 calc(50% - 50vw);
    `)}
  }
`

export const ActionBarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: ${Z.Child};
  ${IsMobile(css`
    bottom: 16px;
  `)}
`
